import { PureComponent } from 'react';
import { capitalize } from 'lodash-es';

import * as rq from 'constants/helpCenter';
import RouteNotFound from 'components/RouteNotFound';
import { trimName } from '../../utils';

import { Article, Sidebar } from './components';

class Page extends PureComponent {
  state = {
    fetching: true,
    fetchingArticle: true,
    currentArticle: {},
  };

  categories = [];

  collectionName = '';

  async componentDidMount() {
    const { location } = this.props;
    if (location.state) {
      const { article, collectionName, collectionId } = location.state;
      return await this.dataInit(article, collectionName, collectionId);
    }

    try {
      await this.dataInit();
    } catch (err) {
      return this.setState({ notFound: true });
    }
  }

  componentDidUpdate(prevProps) {
    const prevSlug = prevProps.match.params.articleSlug;
    const { articleSlug } = this.props.match.params;

    if (prevSlug !== articleSlug) {
      this.fetchArticle(articleSlug);
    }
  }

  async dataInit(article, collectionName, collectionId) {
    let id = collectionId;

    if (id) {
      this.collectionName = collectionName;
    } else {
      const collection = await this.getCollectionData();

      id = collection.id;
      this.collectionName = trimName(collection.name);
    }

    this.categories = await this.getCategoriesData(id);

    if (article) {
      return this.setState({
        currentArticle: article,
        fetchingArticle: false,
        fetching: false,
      });
    }

    const { match } = this.props;

    let { articleSlug } = match.params;

    if (!articleSlug) {
      articleSlug = this.categories[0].articles[0].slug;
      window.location.href = `${location.pathname}/${articleSlug}`;
    }

    await this.fetchArticle(articleSlug);
  }

  async getData(type, payload) {
    const {
      data: {
        [type]: { items },
      },
    } = await rq[`get${capitalize(type)}`](payload);

    return items;
  }

  fetchArticle = async (slug) => {
    this.setState({ fetchingArticle: true });

    const { id } = this.findArticleInCategory(slug);
    const {
      data: { article },
    } = await rq.getArticle(id);

    this.setState({
      currentArticle: { ...article, categoryId: article.categories[0] },
      fetchingArticle: false,
      fetching: false,
    });
  };

  async getCategoriesData(collectionId) {
    const categories = await this.getData('categories', collectionId);

    const NotEmptyCategories = categories.filter((category) => category.publishedArticleCount > 0);

    return await Promise.all(
      NotEmptyCategories.map(async (category) => {
        const articles = await this.getData('articles', category.id);

        return {
          ...category,
          articles: articles.filter((item) => item.status === 'published'),
        };
      })
    );
  }

  findArticleInCategory(slug) {
    let result;
    this.categories.find((category) =>
      category.articles.find((article) => {
        if (article.slug === slug) {
          result = article;
          return true;
        }
        return false;
      })
    );

    return result;
  }

  async getCollectionData() {
    const { collectionSlug } = this.props.match.params;

    const collections = await this.getData('collections');

    const currentCollection = collections.find(
      (collection) => collection.slug.indexOf(collectionSlug) >= 0
    );

    return currentCollection;
  }

  render() {
    const { fetching, fetchingArticle, currentArticle, notFound } = this.state;

    if (notFound) {
      return <RouteNotFound />;
    }

    return (
      <section className="section section_search-article">
        {!fetching ? (
          <div className="wrapper">
            <div className="row">
              <div className="col col-3 col-tablet-12">
                <Sidebar
                  categories={this.categories}
                  currentCategoryId={currentArticle.categoryId}
                  collectionName={this.collectionName}
                  test={!fetching}
                />
              </div>
              <div className="col col-9 col-tablet-12">
                <Article article={currentArticle} test={!fetchingArticle} />
              </div>
            </div>
          </div>
        ) : (
          <div className="spinner" />
        )}
      </section>
    );
  }
}

export default Page;
